import { sortBy, isNumber, isNil } from 'lodash';
import { RadioGroupTypes } from './types';

const DEFAULT_CONFIDENCE_SCORE = 0.8;

export const valueIsCustomOrNone = (value: any) => {
  return value === RadioGroupTypes.NONE || value === RadioGroupTypes.CUSTOM;
};

const areArraysEqual: any = (
  arrayOne: any[],
  arrayTwo: any[],
  strict?: boolean,
) => {
  if (!arrayOne || !arrayTwo) return false;
  if (arrayOne.length !== arrayTwo.length) return false;
  for (let i = 0; i < arrayOne.length; i++) {
    if (arrayOne[i] instanceof Array && arrayTwo[i] instanceof Array) {
      if (!areArraysEqual(arrayOne[i], arrayTwo[i], strict)) return false;
    } else if (strict && arrayOne[i] !== arrayTwo[i]) {
      return false;
    } else if (!strict) {
      return areArraysEqual(arrayOne.sort(), arrayTwo.sort(), true);
    }
  }
  return true;
};

export const isValidString = (str: string) =>
  typeof str === 'string' && str.trim().length > 0;

const isValidPrimitive = (value: any) =>
  typeof value === 'number' || typeof value === 'string';

const isValidValue = (value: any) =>
  (typeof value === 'boolean' && value) ||
  isNumber(value) ||
  (Array.isArray(value) && value.length) ||
  isValidString(value);

const hasValue = (value: any) =>
  !isNil(value) &&
  (typeof value === 'boolean' ||
    isNumber(value) ||
    (Array.isArray(value) && value.length) ||
    isValidString(value));

const areValuesEqual: any = (value: any, valueToCompare: any) => {
  if (isValidString(value) && isValidString(valueToCompare)) {
    return value.trim().toLowerCase() === valueToCompare.trim().toLowerCase();
  }

  if (isValidPrimitive(value) && isValidPrimitive(valueToCompare)) {
    // the new normalize backend logic will accept, numbers, strings and fix these
    // meaning if the value is a simple primitive: 6 and '6' are equal
    // eslint-disable-next-line eqeqeq
    return value == valueToCompare;
  }

  const hasCurrentValue = hasValue(value);
  const hasPreviousValue = hasValue(valueToCompare);
  return hasCurrentValue && hasPreviousValue && value === valueToCompare;
};

const sortRecords = (records: any[]) => {
  return sortBy(records, [
    (record: any) => -record.Year,
    (record: any) => -new Date(record.Data.MLS_LIST_DATE).getTime(),
  ]);
};

const formatValue = (value: any, ControlType: string | undefined) => {
  if (ControlType === 'CurrencyField') {
    const parts = value.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (parts[1]?.length) parts[1] = parts[1].substring(0, 2);
    return `\$${parts.join('.')}`;
  }

  if (typeof value === 'boolean') {
    return value ? 'Yes' : 'No';
  }

  return value;
};

export {
  areArraysEqual,
  areValuesEqual,
  formatValue,
  hasValue,
  isValidValue,
  sortRecords,
};
